import React from "react";
import Footer from "./footer";

function pro(){
    return <div className="h-full w-full bg-black pt-10 text-white">
         <div className="block text-center text-3xl font-semibold border-b-2 border-green-500 pb-10">My Projects</div>
         <div className="flex justify-center">
        <div class="md:grid md:gap-10 block md:grid-cols-2 pb-48 gap-2 pt-4 ">
        <div className="h-fit w-96 bg-slate-50 bg-opacity-5 border-2 border-green-200 rounded-lg mb-2">
             <img className="rounded-lg" src="./resources/agrow.png" alt="head"/>
             <div className="block text-center text-xl font-bold">Agriculture Aid Website provides help to Farmers using AI models.<br/><a href="https://devfolio.co/projects/agrow-tech-48dd"><span  className=" text-sm mb-0 border-b-2">Built for Hackodisha 3.0 - 4th position</span></a></div>
            <div className="flex justify-evenly pt-4 text-black">
                <a href="https://coperiax.netlify.app"><div className="h-fit w-fit p-2 rounded-3xl bg-green-500 hover:bg-green-300 font-medium">Try it Out</div></a>
                <a href="https://github.com/4n1rudh4/coperiax"><div className="h-fit w-fit p-2 rounded-3xl bg-green-500 hover:bg-green-300 font-medium">Repo</div></a>
            </div>
        </div>
        <div className="h-80 w-96 bg-slate-50 bg-opacity-5 border-2 border-green-200 rounded-lg mb-2">
             <img className="rounded-lg" src="./resources/fender.png" alt="head"/>
             <div className="block text-center text-xl font-bold">E-commerce website built using React.</div>
             
             <div className="flex justify-evenly pt-4 text-black">
                <a href="https://fenderindia.netlify.app"><div className="h-fit w-fit p-2 rounded-3xl bg-green-500 font-medium hover:bg-green-300">Try it Out</div></a>
                <a href="https://github.com/4n1rudh4/project_fender"><div className="h-fit w-fit p-2 rounded-3xl bg-green-500  font-medium hover:bg-green-300">Repo</div></a>
            </div>
        </div>
        <div className="h-80 w-96 bg-slate-50 bg-opacity-5 border-2 border-green-200 rounded-lg mb-2">
             <img className="rounded-lg" src="./resources/space.png" alt="head"/>
             <div className="block text-center text-xl font-bold">Spaceflight news through API</div>
             <div className="flex justify-evenly pt-4 text-black">
                <a href="https://spaceflightnew.netlify.app"><div className="h-fit w-fit p-2 rounded-3xl bg-green-500  font-medium hover:bg-green-300">Try it Out</div></a>
                <a href="https://github.com/4n1rudh4/spaceflight_news"><div className="h-fit w-fit p-2 rounded-3xl bg-green-500  font-medium hover:bg-green-300">Repo</div></a>
            </div>
        </div>
        <div className="h-80 w-96 bg-slate-50 bg-opacity-5 border-2 border-green-200 rounded-lg mb-2">
             <img className="rounded-lg" src="./resources/ss.png" alt="head"/>
             <div className="block text-center text-xl font-bold">Jokes</div>
             <div className="flex justify-evenly pt-4 text-black">
                <a href="https://joke4n1.netlify.app"><div className="h-fit w-fit p-2 rounded-3xl bg-green-500  font-medium hover:bg-green-300">Try it Out</div></a>
                <a href="https://github.com/4n1rudh4/jokes"><div className="h-fit w-fit p-2 rounded-3xl bg-green-500  font-medium hover:bg-green-300">Repo</div></a>
            </div>
        </div>
        
        </div>  
        </div>
         <div  className="flex justify-center">
            <Footer/>
        </div>
    </div>
}

export default pro;